export const isEmptyObject = (model, value) =>
  !Object.keys(model.properties).some(key => Object.keys(value).some(item => item === key))



// WEBPACK FOOTER //
// ./src/entries/helpers/isEmptyObject.js